export default "__VITE_ASSET__D1YXetM9__"